import { lazy } from "react";
import routes from "./routesConfig/index";

const ContractPage = lazy(() => import('../Contract/Contract'));

const contractRoutes = [
  { path: routes.contracts, component: ContractPage, moduleKey: "contract", permissionKey: "contract_global_list" },
];

export default contractRoutes;
